import { render, staticRenderFns } from "./viewdetail.vue?vue&type=template&id=506e7e9e&scoped=true&"
import script from "./viewdetail.vue?vue&type=script&lang=js&"
export * from "./viewdetail.vue?vue&type=script&lang=js&"
import style0 from "./viewdetail.vue?vue&type=style&index=0&id=506e7e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e7e9e",
  null
  
)

export default component.exports